module.exports = __webpack_public_path__ + "static/media/4_bestellen.ae75d23c.jpg";